import type { ComicEpisode, ComicProject } from './comicTypes'

/** 用于对比「已保存」快照的精简序列化（不含 updatedAt 等元数据） */
export function snapshotEpisode(ep: ComicEpisode): string {
  return JSON.stringify({
    id: ep.id,
    index: ep.index,
    title: ep.title,
    pages: ep.pages,
    panels: ep.panels.map((p) => ({
      id: p.id,
      order: p.order,
      script: p.script,
      dialogue: p.dialogue,
      narration: p.narration ?? '',
      imageUrl: p.imageUrl,
      selectedCandidateId: p.selectedCandidateId,
      candidates: p.candidates,
      status: p.status,
      errorMessage: p.errorMessage ?? null,
      creationTaskId: p.creationTaskId,
    })),
  })
}

export function buildEpisodeSnapshots(project: ComicProject): Map<string, string> {
  const map = new Map<string, string>()
  for (const ep of project.episodes) {
    map.set(ep.id, snapshotEpisode(ep))
  }
  return map
}

export function isEpisodeDirty(
  episode: ComicEpisode,
  savedSnapshots: Map<string, string>,
): boolean {
  const saved = savedSnapshots.get(episode.id)
  if (!saved) return true
  return saved !== snapshotEpisode(episode)
}

export function isProjectDirty(
  project: ComicProject,
  savedSnapshots: Map<string, string>,
): boolean {
  return project.episodes.some((ep) => isEpisodeDirty(ep, savedSnapshots))
}
